import { render } from "./TodoItems.vue?vue&type=template&id=63ec1917"
import script from "./TodoItems.vue?vue&type=script&lang=js"
export * from "./TodoItems.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__